import React, { createContext, useContext, useState, useEffect } from 'react';
import coreExtra from '../i18n/coreExtra';
import landing from '../i18n/landing';
import pages from '../i18n/pages';
import pwa from '../i18n/pwa';

// Translations
const translations = {
  pt: {
    // Common
    save: 'Guardar',
    cancel: 'Cancelar',
    close: 'Fechar',
    edit: 'Editar',
    delete: 'Eliminar',
    search: 'Pesquisar',
    loading: 'A carregar...',
    error: 'Erro',
    success: 'Sucesso',
    
    // Navigation
    dashboard: 'Dashboard',
    profile: 'Perfil',
    generatePlan: 'Gerar Plano',
    history: 'Historico',
    progression: 'Progressão',
    timer: 'Timer',
    strava: 'Strava',
    reminders: 'Lembretes',
    plans: 'Planos',
    admin: 'Admin',
    assistant: 'Assistente IA',
    exercises: 'Exercícios',
    logout: 'Sair',
    
    // Dashboard
    welcome: 'Bem-vindo de volta',
    hello: 'Ola',
    completeProfile: 'Completa o teu perfil',
    completeProfileDesc: 'Preenche as tuas informacoes para receber planos de treino personalizados.',
    generateNewPlan: 'Gerar Novo Plano',
    generateNewPlanDesc: 'Cria um plano de cardio personalizado com IA baseado no teu perfil e objetivos.',
    createPlan: 'Criar Plano',
    totalPlans: 'Total de Planos',
    completedSessions: 'Sessoes Completas',
    averageRating: 'Avaliacao Media',
    progressRecords: 'Registos de Progresso',
    recentPlans: 'Planos Recentes',
    
    // Profile
    personalData: 'Dados Pessoais',
    physicalData: 'Dados Fisicos',
    trainingPreferences: 'Preferencias de Treino',
    age: 'Idade',
    weight: 'Peso',
    height: 'Altura',
    experienceLevel: 'Nivel de Experiencia',
    beginner: 'Iniciante',
    intermediate: 'Intermediario',
    advanced: 'Avancado',
    weeklyFrequency: 'Frequencia Semanal',
    goals: 'Objetivos',
    injuries: 'Lesoes',
    restrictions: 'Restricoes',
    preferredCardio: 'Cardio Preferido',
    gender: 'Genero',
    male: 'Masculino',
    female: 'Feminino',
    other: 'Outro',
    location: 'Localizacao',
    phone: 'Telefone',
    birthDate: 'Data de Nascimento',
    language: 'Idioma',
    selectLanguage: 'Selecionar idioma',
    
    // Generate Plan
    generatePlanTitle: 'Gerar Plano',
    generatePlanDesc: 'Cria um plano de treino personalizado com IA',
    yourProfile: 'O Teu Perfil',
    dataUsedForPersonalization: 'Dados usados para personalizacao',
    configurePlan: 'Configurar Plano',
    workoutType: 'Tipo de Treino',
    trainingLocation: 'Local de Treino',
    duration: 'Duracao do Plano',
    weeks: 'semanas',
    cardioTypes: 'Tipos de Cardio',
    muscleGroups: 'Grupos Musculares',
    selectMuscles: 'Seleciona os musculos que queres treinar',
    specialFocus: 'Foco Especial',
    includeVideos: 'Incluir videos de demonstracao',
    videosDesc: 'Links para videos de cada exercicio',
    generateBtn: 'Gerar Plano de Treino',
    generating: 'A Gerar Plano com IA...',
    
    // Workout Types
    cardio: 'Cardio',
    strength: 'Musculacao',
    hiit: 'HIIT',
    circuit: 'Circuito',
    
    // Locations
    home: 'Casa',
    gym: 'Ginasio',
    both: 'Ambos',
    
    // Muscle Groups
    fullBody: 'Corpo Inteiro',
    chest: 'Peito',
    back: 'Costas',
    shoulders: 'Ombros',
    arms: 'Bracos',
    legs: 'Pernas',
    core: 'Abdomen',
    upperBody: 'Parte Superior',
    lowerBody: 'Parte Inferior',
    
    // Exercise Library
    exerciseLibrary: 'Biblioteca de Exercicios',
    exerciseLibraryDesc: 'Explora exercicios com demonstracoes em video',
    filterByMuscle: 'Filtrar por musculo',
    filterByEquipment: 'Filtrar por equipamento',
    allMuscles: 'Todos os musculos',
    allEquipment: 'Todo o equipamento',
    noExercisesFound: 'Nenhum exercicio encontrado',
    exercisesFound: 'exercicios encontrados',
    viewExercise: 'Ver exercicio',
    
    // Paywall
    premiumFeature: 'Funcionalidade Premium',
    paywallMessage: 'A geracao de planos de treino personalizados esta disponivel apenas para assinantes Pro ou Premium.',
    viewPlansAndUpgrade: 'Ver Planos e Fazer Upgrade',
    
    // Admin
    adminPanel: 'Painel de Administrador',
    adminDesc: 'Gere utilizadores, planos de subscricao e monitoriza a plataforma',
    statistics: 'Estatisticas',
    users: 'Utilizadores',
    totalUsers: 'Total Utilizadores',
    newThisWeek: 'Novos esta Semana',
    generatedPlans: 'Planos Gerados',
    paidUsers: 'Utilizadores Pagos',
    distributionByPlan: 'Distribuicao por Plano',
    free: 'Gratis',
    pro: 'Pro',
    premium: 'Premium',
    userList: 'Lista de Utilizadores',
    filterByPlan: 'Filtrar por plano',
    allPlans: 'Todos os planos',
    editUser: 'Editar Utilizador',
    userRole: 'Funcao',
    user: 'Utilizador',
    administrator: 'Administrador',
    
    // Pricing
    pricing: 'Precos',
    choosePlan: 'Escolhe o teu plano',
    monthly: 'mes',
    subscribe: 'Subscrever',
    currentPlan: 'Plano Atual',
    
    // Auth
    login: 'Entrar',
    register: 'Criar conta',
    email: 'Email',
    password: 'Palavra-passe',
    name: 'Nome',
    noAccount: 'Nao tens uma conta?',
    hasAccount: 'Ja tens uma conta?',
    createAccount: 'Criar conta',
    welcomeBack: 'Bem-vindo de volta',
    continueJourney: 'Continua a tua jornada de treino personalizado com IA.',
  },
  
  en: {
    // Common
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    edit: 'Edit',
    delete: 'Delete',
    search: 'Search',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    
    // Navigation
    dashboard: 'Dashboard',
    profile: 'Profile',
    generatePlan: 'Generate Plan',
    history: 'History',
    progression: 'Progression',
    timer: 'Timer',
    strava: 'Strava',
    reminders: 'Reminders',
    plans: 'Plans',
    admin: 'Admin',
    assistant: 'AI Assistant',
    exercises: 'Exercises',
    logout: 'Logout',
    
    // Dashboard
    welcome: 'Welcome back',
    hello: 'Hello',
    completeProfile: 'Complete your profile',
    completeProfileDesc: 'Fill in your information to receive personalized workout plans.',
    generateNewPlan: 'Generate New Plan',
    generateNewPlanDesc: 'Create a personalized cardio plan with AI based on your profile and goals.',
    createPlan: 'Create Plan',
    totalPlans: 'Total Plans',
    completedSessions: 'Completed Sessions',
    averageRating: 'Average Rating',
    progressRecords: 'Progress Records',
    recentPlans: 'Recent Plans',
    
    // Profile
    personalData: 'Personal Data',
    physicalData: 'Physical Data',
    trainingPreferences: 'Training Preferences',
    age: 'Age',
    weight: 'Weight',
    height: 'Height',
    experienceLevel: 'Experience Level',
    beginner: 'Beginner',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    weeklyFrequency: 'Weekly Frequency',
    goals: 'Goals',
    injuries: 'Injuries',
    restrictions: 'Restrictions',
    preferredCardio: 'Preferred Cardio',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    location: 'Location',
    phone: 'Phone',
    birthDate: 'Birth Date',
    language: 'Language',
    selectLanguage: 'Select language',
    
    // Generate Plan
    generatePlanTitle: 'Generate Plan',
    generatePlanDesc: 'Create a personalized workout plan with AI',
    yourProfile: 'Your Profile',
    dataUsedForPersonalization: 'Data used for personalization',
    configurePlan: 'Configure Plan',
    workoutType: 'Workout Type',
    trainingLocation: 'Training Location',
    duration: 'Plan Duration',
    weeks: 'weeks',
    cardioTypes: 'Cardio Types',
    muscleGroups: 'Muscle Groups',
    selectMuscles: 'Select the muscles you want to train',
    specialFocus: 'Special Focus',
    includeVideos: 'Include demonstration videos',
    videosDesc: 'Links for videos of each exercise',
    generateBtn: 'Generate Workout Plan',
    generating: 'Generating Plan with AI...',
    
    // Workout Types
    cardio: 'Cardio',
    strength: 'Strength',
    hiit: 'HIIT',
    circuit: 'Circuit',
    
    // Locations
    home: 'Home',
    gym: 'Gym',
    both: 'Both',
    
    // Muscle Groups
    fullBody: 'Full Body',
    chest: 'Chest',
    back: 'Back',
    shoulders: 'Shoulders',
    arms: 'Arms',
    legs: 'Legs',
    core: 'Core',
    upperBody: 'Upper Body',
    lowerBody: 'Lower Body',
    
    // Exercise Library
    exerciseLibrary: 'Exercise Library',
    exerciseLibraryDesc: 'Explore exercises with video demonstrations',
    filterByMuscle: 'Filter by muscle',
    filterByEquipment: 'Filter by equipment',
    allMuscles: 'All muscles',
    allEquipment: 'All equipment',
    noExercisesFound: 'No exercises found',
    exercisesFound: 'exercises found',
    viewExercise: 'View exercise',
    
    // Paywall
    premiumFeature: 'Premium Feature',
    paywallMessage: 'Personalized workout plan generation is only available for Pro or Premium subscribers.',
    viewPlansAndUpgrade: 'View Plans and Upgrade',
    
    // Admin
    adminPanel: 'Admin Panel',
    adminDesc: 'Manage users, subscription plans and monitor the platform',
    statistics: 'Statistics',
    users: 'Users',
    totalUsers: 'Total Users',
    newThisWeek: 'New This Week',
    generatedPlans: 'Generated Plans',
    paidUsers: 'Paid Users',
    distributionByPlan: 'Distribution by Plan',
    free: 'Free',
    pro: 'Pro',
    premium: 'Premium',
    userList: 'User List',
    filterByPlan: 'Filter by plan',
    allPlans: 'All plans',
    editUser: 'Edit User',
    userRole: 'Role',
    user: 'User',
    administrator: 'Administrator',
    
    // Pricing
    pricing: 'Pricing',
    choosePlan: 'Choose your plan',
    monthly: 'month',
    subscribe: 'Subscribe',
    currentPlan: 'Current Plan',
    
    // Auth
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    createAccount: 'Create account',
    welcomeBack: 'Welcome back',
    continueJourney: 'Continue your personalized AI training journey.',
  },
  
  es: {
    // Common
    save: 'Guardar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    edit: 'Editar',
    delete: 'Eliminar',
    search: 'Buscar',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Exito',
    
    // Navigation
    dashboard: 'Panel',
    profile: 'Perfil',
    generatePlan: 'Generar Plan',
    history: 'Historial',
    progression: 'Progresion',
    timer: 'Temporizador',
    strava: 'Strava',
    reminders: 'Recordatorios',
    plans: 'Planes',
    admin: 'Admin',
    assistant: 'Asistente IA',
    exercises: 'Ejercicios',
    logout: 'Salir',
    
    // Dashboard
    welcome: 'Bienvenido de nuevo',
    hello: 'Hola',
    completeProfile: 'Completa tu perfil',
    completeProfileDesc: 'Rellena tu informacion para recibir planes de entrenamiento personalizados.',
    generateNewPlan: 'Generar Nuevo Plan',
    generateNewPlanDesc: 'Crea un plan de cardio personalizado con IA basado en tu perfil y objetivos.',
    createPlan: 'Crear Plan',
    totalPlans: 'Total de Planes',
    completedSessions: 'Sesiones Completadas',
    averageRating: 'Valoracion Media',
    progressRecords: 'Registros de Progreso',
    recentPlans: 'Planes Recientes',
    
    // Profile
    personalData: 'Datos Personales',
    physicalData: 'Datos Fisicos',
    trainingPreferences: 'Preferencias de Entrenamiento',
    age: 'Edad',
    weight: 'Peso',
    height: 'Altura',
    experienceLevel: 'Nivel de Experiencia',
    beginner: 'Principiante',
    intermediate: 'Intermedio',
    advanced: 'Avanzado',
    weeklyFrequency: 'Frecuencia Semanal',
    goals: 'Objetivos',
    injuries: 'Lesiones',
    restrictions: 'Restricciones',
    preferredCardio: 'Cardio Preferido',
    gender: 'Genero',
    male: 'Masculino',
    female: 'Femenino',
    other: 'Otro',
    location: 'Ubicacion',
    phone: 'Telefono',
    birthDate: 'Fecha de Nacimiento',
    language: 'Idioma',
    selectLanguage: 'Seleccionar idioma',
    
    // Generate Plan
    generatePlanTitle: 'Generar Plan',
    generatePlanDesc: 'Crea un plan de entrenamiento personalizado con IA',
    yourProfile: 'Tu Perfil',
    dataUsedForPersonalization: 'Datos usados para personalizacion',
    configurePlan: 'Configurar Plan',
    workoutType: 'Tipo de Entrenamiento',
    trainingLocation: 'Lugar de Entrenamiento',
    duration: 'Duracion del Plan',
    weeks: 'semanas',
    cardioTypes: 'Tipos de Cardio',
    muscleGroups: 'Grupos Musculares',
    selectMuscles: 'Selecciona los musculos que quieres entrenar',
    specialFocus: 'Enfoque Especial',
    includeVideos: 'Incluir videos de demostracion',
    videosDesc: 'Links para videos de cada ejercicio',
    generateBtn: 'Generar Plan de Entrenamiento',
    generating: 'Generando Plan con IA...',
    
    // Workout Types
    cardio: 'Cardio',
    strength: 'Musculacion',
    hiit: 'HIIT',
    circuit: 'Circuito',
    
    // Locations
    home: 'Casa',
    gym: 'Gimnasio',
    both: 'Ambos',
    
    // Muscle Groups
    fullBody: 'Cuerpo Completo',
    chest: 'Pecho',
    back: 'Espalda',
    shoulders: 'Hombros',
    arms: 'Brazos',
    legs: 'Piernas',
    core: 'Abdomen',
    upperBody: 'Parte Superior',
    lowerBody: 'Parte Inferior',
    
    // Exercise Library
    exerciseLibrary: 'Biblioteca de Ejercicios',
    exerciseLibraryDesc: 'Explora ejercicios con demostraciones en video',
    filterByMuscle: 'Filtrar por musculo',
    filterByEquipment: 'Filtrar por equipo',
    allMuscles: 'Todos los musculos',
    allEquipment: 'Todo el equipo',
    noExercisesFound: 'No se encontraron ejercicios',
    exercisesFound: 'ejercicios encontrados',
    viewExercise: 'Ver ejercicio',
    
    // Paywall
    premiumFeature: 'Funcion Premium',
    paywallMessage: 'La generacion de planes de entrenamiento personalizados solo esta disponible para suscriptores Pro o Premium.',
    viewPlansAndUpgrade: 'Ver Planes y Mejorar',
    
    // Admin
    adminPanel: 'Panel de Administrador',
    adminDesc: 'Gestiona usuarios, planes de suscripcion y monitoriza la plataforma',
    statistics: 'Estadisticas',
    users: 'Usuarios',
    totalUsers: 'Total Usuarios',
    newThisWeek: 'Nuevos esta Semana',
    generatedPlans: 'Planes Generados',
    paidUsers: 'Usuarios de Pago',
    distributionByPlan: 'Distribucion por Plan',
    free: 'Gratis',
    pro: 'Pro',
    premium: 'Premium',
    userList: 'Lista de Usuarios',
    filterByPlan: 'Filtrar por plan',
    allPlans: 'Todos los planes',
    editUser: 'Editar Usuario',
    userRole: 'Rol',
    user: 'Usuario',
    administrator: 'Administrador',
    
    // Pricing
    pricing: 'Precios',
    choosePlan: 'Elige tu plan',
    monthly: 'mes',
    subscribe: 'Suscribirse',
    currentPlan: 'Plan Actual',
    
    // Auth
    login: 'Iniciar sesion',
    register: 'Registrarse',
    email: 'Correo electronico',
    password: 'Contrasena',
    name: 'Nombre',
    noAccount: 'No tienes una cuenta?',
    hasAccount: 'Ya tienes una cuenta?',
    createAccount: 'Crear cuenta',
    welcomeBack: 'Bienvenido de nuevo',
    continueJourney: 'Continua tu viaje de entrenamiento personalizado con IA.',
  },
  
  fr: {
    // Common
    save: 'Enregistrer',
    cancel: 'Annuler',
    close: 'Fermer',
    edit: 'Modifier',
    delete: 'Supprimer',
    search: 'Rechercher',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succes',
    
    // Navigation
    dashboard: 'Tableau de bord',
    profile: 'Profil',
    generatePlan: 'Generer un Plan',
    history: 'Historique',
    progression: 'Progression',
    timer: 'Minuteur',
    strava: 'Strava',
    reminders: 'Rappels',
    plans: 'Plans',
    admin: 'Admin',
    assistant: 'Assistant IA',
    exercises: 'Exercices',
    logout: 'Deconnexion',
    
    // Dashboard
    welcome: 'Bon retour',
    hello: 'Bonjour',
    completeProfile: 'Completez votre profil',
    completeProfileDesc: 'Remplissez vos informations pour recevoir des plans personnalises.',
    generateNewPlan: 'Generer un Nouveau Plan',
    generateNewPlanDesc: 'Creez un plan cardio personnalise avec IA base sur votre profil et vos objectifs.',
    createPlan: 'Creer un Plan',
    totalPlans: 'Total des Plans',
    completedSessions: 'Seances Completees',
    averageRating: 'Note Moyenne',
    progressRecords: 'Enregistrements de Progres',
    recentPlans: 'Plans Recents',
    
    // Profile
    personalData: 'Donnees Personnelles',
    physicalData: 'Donnees Physiques',
    trainingPreferences: "Preferences d'Entrainement",
    age: 'Age',
    weight: 'Poids',
    height: 'Taille',
    experienceLevel: "Niveau d'Experience",
    beginner: 'Debutant',
    intermediate: 'Intermediaire',
    advanced: 'Avance',
    weeklyFrequency: 'Frequence Hebdomadaire',
    goals: 'Objectifs',
    injuries: 'Blessures',
    restrictions: 'Restrictions',
    preferredCardio: 'Cardio Prefere',
    gender: 'Genre',
    male: 'Masculin',
    female: 'Feminin',
    other: 'Autre',
    location: 'Localisation',
    phone: 'Telephone',
    birthDate: 'Date de Naissance',
    language: 'Langue',
    selectLanguage: 'Selectionner la langue',
    
    // Generate Plan
    generatePlanTitle: 'Generer un Plan',
    generatePlanDesc: "Creez un plan d'entrainement personnalise avec IA",
    yourProfile: 'Votre Profil',
    dataUsedForPersonalization: 'Donnees utilisees pour la personnalisation',
    configurePlan: 'Configurer le Plan',
    workoutType: "Type d'Entrainement",
    trainingLocation: "Lieu d'Entrainement",
    duration: 'Duree du Plan',
    weeks: 'semaines',
    cardioTypes: 'Types de Cardio',
    muscleGroups: 'Groupes Musculaires',
    selectMuscles: 'Selectionnez les muscles que vous voulez entrainer',
    specialFocus: 'Focus Special',
    includeVideos: 'Inclure des videos de demonstration',
    videosDesc: 'Liens vers des videos pour chaque exercice',
    generateBtn: "Generer le Plan d'Entrainement",
    generating: 'Generation du Plan avec IA...',
    
    // Workout Types
    cardio: 'Cardio',
    strength: 'Musculation',
    hiit: 'HIIT',
    circuit: 'Circuit',
    
    // Locations
    home: 'Maison',
    gym: 'Salle de sport',
    both: 'Les deux',
    
    // Muscle Groups
    fullBody: 'Corps Entier',
    chest: 'Poitrine',
    back: 'Dos',
    shoulders: 'Epaules',
    arms: 'Bras',
    legs: 'Jambes',
    core: 'Abdominaux',
    upperBody: 'Haut du Corps',
    lowerBody: 'Bas du Corps',
    
    // Exercise Library
    exerciseLibrary: "Bibliotheque d'Exercices",
    exerciseLibraryDesc: 'Explorez des exercices avec demonstrations video',
    filterByMuscle: 'Filtrer par muscle',
    filterByEquipment: 'Filtrer par equipement',
    allMuscles: 'Tous les muscles',
    allEquipment: 'Tout equipement',
    noExercisesFound: 'Aucun exercice trouve',
    exercisesFound: 'exercices trouves',
    viewExercise: "Voir l'exercice",
    
    // Paywall
    premiumFeature: 'Fonction Premium',
    paywallMessage: "La generation de plans d'entrainement personnalises n'est disponible que pour les abonnes Pro ou Premium.",
    viewPlansAndUpgrade: 'Voir les Plans et Ameliorer',
    
    // Admin
    adminPanel: "Panneau d'Administration",
    adminDesc: 'Gerez les utilisateurs, les plans et surveillez la plateforme',
    statistics: 'Statistiques',
    users: 'Utilisateurs',
    totalUsers: 'Total Utilisateurs',
    newThisWeek: 'Nouveaux cette Semaine',
    generatedPlans: 'Plans Generes',
    paidUsers: 'Utilisateurs Payants',
    distributionByPlan: 'Distribution par Plan',
    free: 'Gratuit',
    pro: 'Pro',
    premium: 'Premium',
    userList: 'Liste des Utilisateurs',
    filterByPlan: 'Filtrer par plan',
    allPlans: 'Tous les plans',
    editUser: "Modifier l'Utilisateur",
    userRole: 'Role',
    user: 'Utilisateur',
    administrator: 'Administrateur',
    
    // Pricing
    pricing: 'Tarification',
    choosePlan: 'Choisissez votre plan',
    monthly: 'mois',
    subscribe: "S'abonner",
    currentPlan: 'Plan Actuel',
    
    // Auth
    login: 'Connexion',
    register: "S'inscrire",
    email: 'Email',
    password: 'Mot de passe',
    name: 'Nom',
    noAccount: "Vous n'avez pas de compte?",
    hasAccount: 'Vous avez deja un compte?',
    createAccount: 'Creer un compte',
    welcomeBack: 'Bon retour',
    continueJourney: "Continuez votre parcours d'entrainement personnalise avec IA.",
  }
};

const languageNames = {
  pt: 'Português',
  en: 'English',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  it: 'Italiano'
};

const languageFlags = {
  pt: '🇵🇹',
  en: '🇬🇧',
  es: '🇪🇸',
  fr: '🇫🇷',
  de: '🇩🇪',
  it: '🇮🇹'
};

Object.assign(translations, coreExtra);

Object.keys(pages).forEach((code) => {
  translations[code] = { ...(translations[code] || {}), ...pages[code] };
});

Object.keys(pwa).forEach((code) => {
  translations[code] = { ...(translations[code] || {}), ...pwa[code] };
});

// Nationality labels for the languages declared inline above
translations.pt.nationality = 'Nacionalidade';
translations.pt.selectNationality = 'Seleciona a tua nacionalidade';
translations.en.nationality = 'Nationality';
translations.en.selectNationality = 'Select your nationality';
translations.es.nationality = 'Nacionalidad';
translations.es.selectNationality = 'Selecciona tu nacionalidad';
translations.fr.nationality = 'Nationalité';
translations.fr.selectNationality = 'Sélectionne ta nationalité';

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

const SUPPORTED = ['pt', 'en', 'es', 'fr', 'de', 'it'];

// First visit: follow the language of the device/browser when we support it
const detectLanguage = () => {
  const saved = localStorage.getItem('processbody_language');
  if (saved && SUPPORTED.includes(saved)) return saved;

  const candidates = [...(navigator.languages || []), navigator.language].filter(Boolean);
  for (const candidate of candidates) {
    const code = candidate.toLowerCase().split('-')[0];
    if (SUPPORTED.includes(code)) return code;
  }
  return 'pt';
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(detectLanguage);

  useEffect(() => {
    localStorage.setItem('processbody_language', language);

    // Keep the server copy in sync so transactional e-mails use the same language
    const token = localStorage.getItem('cardioai_token');
    if (token) {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/user/language`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ language })
      }).catch(() => {});
    }
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || translations.pt[key] || key;
  };

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  const value = {
    language,
    setLanguage: changeLanguage,
    t,
    landing: landing[language] || landing.en,
    languages: Object.keys(translations),
    languageNames,
    languageFlags
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
